<template>
  <el-container style="height: 100%">
    <el-header style="height: 50px;padding: 0px;">
      <van-nav-bar title="大健康数据汇总" left-text="返回" left-arrow @click-left="historyBack"/>
    </el-header>
    <el-main style="height: calc(100% - 50px);padding:0px" >
      <el-table v-loading="queryLoadBtton" height="100%"  size="mini" :data="bigHealthyInfos" @cell-click="openHealthyDetal" highlight-current-row>
        <el-table-column label="门店名称" prop="storename"  align="center" width="100" fixed></el-table-column>
        <el-table-column label="总人数" prop="total"  align="center" ></el-table-column>
        <el-table-column label="1次" prop="one" width="60"  align="center" ></el-table-column>
        <el-table-column label="2次" prop="two" width="60" align="center" ></el-table-column>
        <el-table-column label="3次" prop="three" width="60"  align="center" ></el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      queryLoadBtton:false,
      bigHealthyInfos:[],
      storeid:localStorage.getItem("parentstoreid"),
      staffid:localStorage.getItem("staffid"),
    }
  },
  created() {
    this.getBigHealthyInfo();
  },
  methods:{
    openHealthyDetal(row){
      this.$router.push({path:"/bighealthy",query:{
          storeid:row.storeid,
        }});
    },
    getBigHealthyInfo(){
      this.$post("cardmanager/getBigHealthyInfo",{storeid:this.storeid,staffid:this.staffid}).then(res=>{
        if(res.sucess){
          this.bigHealthyInfos=res.object;
        }
        else{
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/beauty/bighealthytotal.vue